import React, {FC} from 'react';

import Stack from '@mui/material/Stack';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import GeomaticoLink from '../../components/GeomaticoLink';
import Highlight from 'react-highlight';

const ScrollableContent = styled(Box)({
  overflow: 'auto',
  padding: '8px',
});

const stackSx = {
  height: '100%',
  overflow: 'hidden'
};

export type SidePanelContentProps = {
  mapStyle: string,
  onMapStyleChanged: (style: string) => void
};

const codeExample = `import mlcontour from 'maplibre-contour';

const demSource = new mlcontour.DemSource({
  url: 'https://.../{z}/{x}/{y}.png',
  encoding: 'mapbox',
  maxzoom: 17,
  worker: true,
});
demSource.setupMaplibre(maplibregl);

const sources = {
  'contour-source': {
    type: 'vector',
    tiles: [
      demSource.contourProtocolUrl({
        thresholds: {
          // zoom: [minor, major]
          11: [200, 1000],
          12: [100, 500],
          14: [50, 200],
          15: [20, 100],
          16: [10, 50],
        }
    ]
  }
};`;

const SidePanelContent: FC<SidePanelContentProps> = () =>
  <Stack sx={stackSx}>
    <ScrollableContent>
      <h1>TODO: Integrate with maplibre-contour</h1>
      <Highlight className="typescript">
        {codeExample}
      </Highlight>
    </ScrollableContent>
    <GeomaticoLink/>
  </Stack>
;

export default SidePanelContent;
